import React from 'react';
import { translate } from '../../../Services/translation';

const ErrorModalComponent = ({ onBack, onRedirect }) => {
  return (
    <div className="modal-error-container">
      <p className="modal-error-container--title">
        {translate('investment-page-modal-error-title')}
      </p>
      <p className="modal-error-container--text">
        {translate('investment-page-modal-error-text')}
      </p>

      <div className="modal-error-container--button-container">
        <button
          onClick={onBack}
          className="modal-error-container--button-container--back"
        >
          {translate('investment-page-modal-button-back')}
        </button>
        <button
          onClick={onRedirect}
          className="modal-error-container--button-container--home"
        >
          {translate('investment-page-modal-button-to-home')}
        </button>
      </div>
    </div>
  );
};

export default ErrorModalComponent;
